import { ProjectLogisticsFromValue } from '@modules/orders-and-trips/types/project-logistics';
import { isString } from 'lodash';

export const getProjectLogisticPayloadValue = (value: ProjectLogisticsFromValue): string => {
  if (isString(value)) {
    return value;
  }
  return value ? 'Да' : 'Нет';
};
